import { render, staticRenderFns } from "./WkField.vue?vue&type=template&id=2f9f5286&scoped=true"
import script from "./WkField.vue?vue&type=script&lang=js"
export * from "./WkField.vue?vue&type=script&lang=js"
import style0 from "./WkField.vue?vue&type=style&index=0&id=2f9f5286&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9f5286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f9f5286')) {
      api.createRecord('2f9f5286', component.options)
    } else {
      api.reload('2f9f5286', component.options)
    }
    module.hot.accept("./WkField.vue?vue&type=template&id=2f9f5286&scoped=true", function () {
      api.rerender('2f9f5286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkForm/WkField.vue"
export default component.exports